export const userRoles: Record<string, UserRole> = {
  anonymous: 'Anonymous',
  customer: 'Customer',
  partner: 'Partner',
  staff: 'Staff',
  eslApplicant: 'ESL Applicant',
} as const;

export type UserRole = 'Anonymous' | 'Customer' | 'Partner' | 'Staff' | 'ESL Applicant';
